import { render, staticRenderFns } from "./DataSourceModal.vue?vue&type=template&id=47306f0c&"
import script from "./DataSourceModal.vue?vue&type=script&lang=js&"
export * from "./DataSourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47306f0c')) {
      api.createRecord('47306f0c', component.options)
    } else {
      api.reload('47306f0c', component.options)
    }
    module.hot.accept("./DataSourceModal.vue?vue&type=template&id=47306f0c&", function () {
      api.rerender('47306f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/modules/DataSourceModal.vue"
export default component.exports